import Input from "components/Input";
import Label from "components/Label";
import React from "react";
import { twMerge } from "tailwind-merge";

export default function InputField({
  label,
  hint,
  invalid = false,
  id,
  className,
  inputClassName,
  ...props
}) {
  return (
    <div className={twMerge("relative mb-4", className)}>
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        {...props}
        className={twMerge(inputClassName, invalid && "invalid")}
      />
      <p className="opacity-90 tracking-wide mt-1 text-xs italic">{hint}</p>
    </div>
  );
}
